module.exports = __webpack_public_path__ + "img/NBA_SingleShot.009b150c.png";